<template>
 <v-row row wrap>

    <v-col cols="12" sm="6" md="4" offset-md="8" offset-sm="6">
        <search-input  @search="performSearch" v-model="search" />
    </v-col>

    <v-col cols="12">

       <div class="table-fixed-header-wrap">
       <v-data-table
                class="mt-3"
                fixed-header
                height="calc(100vh - 260px)"
                :headers="headers"
                :items="items"
                :search="search"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
        >

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.active="{ item }">
                <v-chip small :color="item.active ? 'success' : 'error'">
                    {{ item.active ? $t('common.active') : $t('common.inactive') }}
                </v-chip>
            </template>

            <template v-slot:item.afipActivo="{ item }">
                <v-chip small :color="item.afipActivo ? 'success' : 'grey'">
                    <v-icon small left>{{ item.afipActivo ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                    {{ item.afipActivo ? $t('admin.company.labels.afipConfigured') : $t('admin.company.labels.afipNotConfigured') }}
                </v-chip>
            </template>

            <template v-slot:item.updatedAt="{ item }">
                {{ getDateTimeFormat(item.updatedAt) }}
            </template>

            <template v-slot:item.action="{ item }">
                <show-button  @click="$emit('show', item)" />
                <edit-button  @click="$emit('update', item)" />
                <delete-button @click="$emit('delete', item)" />
            </template>

        </v-data-table>
       </div>
    </v-col>
</v-row>
</template>

<script>
   import CompanyProvider from "../../../providers/CompanyProvider";
   
   import { EditButton, ShowButton, DeleteButton, SearchInput} from "@dracul/common-frontend"
   import { DayjsMixin } from "@dracul/dayjs-frontend";
    
   
    export default {
        name: "CompanyList",
        components: { EditButton, ShowButton, DeleteButton, SearchInput},
        mixins: [DayjsMixin],
        
        data() {
            return {
                items: [],
                totalItems: null,
                loading: false,
                orderBy: 'updatedAt',
                orderDesc: true,
                itemsPerPage: 5,
                pageNumber: 1,
                search: ''
            }
        },
        computed: {   
          headers () {
            return [
                    //Entity Headers
                    {text: this.$t('admin.company.labels.razonSocial'), value: 'razonSocial'},
                    {text: this.$t('admin.company.labels.emailComercial'), value: 'emailComercial'},
                    {text: this.$t('admin.company.labels.telefono'), value: 'telefono'},
                    {text: this.$t('admin.company.labels.emailContactoShort'), value: 'emailContacto'},
                    {text: this.$t('admin.company.labels.cuit'), value: 'cuit'},
                    {text: this.$t('admin.company.labels.nombreFantasia'), value: 'nombreFantasia'},
                    {text: this.$t('admin.company.labels.active'), value: 'active', sortable: false},
                    {text: this.$t('admin.company.labels.afipActivo'), value: 'afipActivo', sortable: false},
                    {text: this.$t('admin.company.labels.updatedAt'), value: 'updatedAt'},
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          } 
        },
        created() {
            this.fetch()
        },
        methods:{
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                CompanyProvider.paginateCompanies(
                    this.pageNumber, 
                    this.itemsPerPage,
                    this.search,
                    this.getOrderBy, 
                    this.getOrderDesc
                ).then(r => {
                    this.items = r.data.companyPaginate.items
                    this.totalItems = r.data.companyPaginate.totalItems
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            }
        }
        
    }
</script>

<style scoped>
.table-fixed-header-wrap {
  min-height: 0;
}
</style>
